import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as legalEntitiesActions from '../../features/todos/actions';
import * as fromActions from '../../features/legal-entities/actions';
import * as fromToDoActions from '../../features/todos/actions';
import * as fromAuthActions from '../../features/auth/actions';
import { ILegalEntitiesBusinessesResponse } from '../../../../src/app/features/todos/models/businesses.model';
import { IBusinessUserRolesRequest } from '../../../../src/app/features/auth/models/business-user-roles.model';

@Injectable({
  providedIn: 'root'
})
export class CheckOneLegalEntityExistsService {
  constructor(private store: Store) {}

  selectTheOneLE(legalEntity: ILegalEntitiesBusinessesResponse) {
    // Set sessionStorage before store dispatches so side nav and other subscribers see the new entity when they react to the store
    sessionStorage.setItem('businessId', legalEntity.legalEntityId);
    sessionStorage.setItem('legalEntity', JSON.stringify(legalEntity));

    this.store.dispatch(fromActions.clearBusinessSelected());
    this.store.dispatch(fromActions.clearAssetManagerViewLinkedBusinesses());
    this.store.dispatch(fromActions.loadClearManageOfferings());
    this.store.dispatch(fromActions.saveSelectedBusinessId({ save: legalEntity.legalEntityId }));
    this.store.dispatch(fromToDoActions.loadSelectedLegalEntity({ selectedLE: legalEntity }));
    this.store.dispatch(fromToDoActions.loadRegulationVerified({ businessId: legalEntity.legalEntityId }));

    const userRolesReq: IBusinessUserRolesRequest = {
      businessId: legalEntity.legalEntityId,
      token: sessionStorage.getItem('token'),
      uniqueDeviceId: '00000000-0000-0000-0000-000000000000'
    };
    this.store.dispatch(fromAuthActions.loadBusinessUserRoles({ request: userRolesReq }));
  }
}
